import React from 'react';
import PropTypes from 'prop-types';
import ScrollingImagesPromoSlideComponent from './ScrollingImagesPromoSlide.styles';
import { SlideImage } from './ScrollingImagesPromoSlide.styles';
import LazyImage from '../LazyImage/LazyImage.jsx';
import {Image, withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';

const ScrollingImagesPromoSlide = ({ rendering, ...props }) => {
  const fields = props.data.fields;
  return (
    <ScrollingImagesPromoSlideComponent>
      <Image
        field={fields.slidingImage}
        imageParams={{ mw: 300, mh: 300, scale: 'both' }}
        style={{ maxWidth: '250px', maxHeight: '250px' }}
      />
    </ScrollingImagesPromoSlideComponent>
  );
};

ScrollingImagesPromoSlide.propTypes = {};

export default withSitecoreContext()(ScrollingImagesPromoSlide);